module.exports = __webpack_public_path__ + "static/media/CSPORT STEREO PRE-AMPLIFIER C3PR.35d04e9a.png";